module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Sammi_CR-5e3f7002b00fa7e69f6e73793b097c9f.jpg";